import { FormInput } from 'presentation/components/form/FormInput.component';
import React from 'react';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';
import { InputDatePicker } from '../../CU-031-01/components/Input';
import { FormRadio } from 'presentation/components/form/FormRadio.component';

const SALE_REQUEST_DEADLINE_OPTIONS = [
    {
        label: '3ヶ月以内（なるべく早く）',
        value: '0',
    },
    {
        label: '6ヶ月以内',
        value: '1',
    },
    {
        label: '1年以内（急いではいない）',
        value: '2',
    },
];

export const SalePrice = (props: { form: any }) => {
    return (
        <React.Fragment>
            <div>
                <FormRadio
                    options={SALE_REQUEST_DEADLINE_OPTIONS}
                    name="saleDueDate"
                    value= 'withi6Months'
                    label="売却希望期限"
                    required
                    style={{ display: 'flex', flexDirection: 'column' }}
                    labelClassName='radio-56'
                    // defaultValue='0'   
                />
            </div>
            <div className="input-56">
                <FormInput
                    name="campaignCode"
                    formatNumber={false}
                    type="number"
                    size={'large'}
                    placeholder={PLACEHOLDER.TEXT}
                    label="キャンペーンコード（任意）"
                    maxLength={20}
                />
            </div>
        </React.Fragment>
    );
};
